module.exports = __webpack_public_path__ + "static/media/RP-79.eceef844.pdf";